import {FETCH_HADITH_CHAPTER} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_HADITH_CHAPTER:
            return action.payload;
        default:
            return state;
    }
};